export default __webpack_public_path__ + "static/media/senior-sample9.c905ad3d.png";